<template>
  <div id="usersComponent">
    <page-title :heading="heading" :subheading="subheading" :icon="icon"></page-title>
    <v-container class="pa-0 pb-5">
      <v-layout class="mb-2" row wrap>
        <v-spacer></v-spacer>
        <v-text-field v-model="userSearch" @click:append="searching" @keyup.enter="searching" :label="$t('general.search')" clearable append-outer-icon="search">
        </v-text-field>
        <v-dialog v-model="dialog" max-width="700px" scrollable persistent>
          <v-btn slot="activator" color="primary" round outline>
            <v-icon left>people</v-icon>
            {{ $t('user.add') }}
          </v-btn>
          <v-card>
            <v-toolbar flat>
              <h2 class="font-weight-black primary--text mb-0">
                {{ formTitle }}
              </h2>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-form
                    lazy-validation
                    ref="form"
                    v-model="valid"
                    v-if="editedItem"
                  >
                    <v-container>
                      <v-layout row wrap>
                        <v-flex xs12 md6>
                          <v-text-field
                            v-model="editedItem.name"
                            :rules="rules.minNameUser"
                            :error-messages="errors.name"
                            :label="$t('general.name')"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            v-model="editedItem.email"
                            :rules="rules.email"
                            :error-messages="errors.email"
                            :disabled="this.editedIndex > -1"
                            clearable
                            :label="$t('general.email')"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            v-model="editedItem.password"
                            :rules="rules.password"
                            :label="$t('login.password')"
                            v-if="isNewItem"
                            :append-icon="
                              showPass ? 'visibility_off' : 'visibility'
                            "
                            :type="showPass ? 'text' : 'password'"
                            :error-messages="errors.password"
                            :hint="
                              $t('general.nonAllowedCharacters') +
                              ': “ _ / ( ) = ¿ ¡ ‘ ` [ + ] ´ ¨ { ç } < > , ; . : _ º ª \ |'
                            "
                            :persistent-hint="true"
                            clearable
                            @click:append="showPass = !showPass"
                          >
                          </v-text-field>
                          <v-text-field
                            v-model="editedItem.password"
                            :label="$t('login.password')"
                            v-if="editingItem"
                            :append-icon="
                              showPass ? 'visibility_off' : 'visibility'
                            "
                            :type="showPass ? 'text' : 'password'"
                            :error-messages="errors.password"
                            @click:append="showPass = !showPass"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-layout xs12 v-if="editedItem.user_info" row wrap>
                          <v-flex xs12 md6>
                            <v-text-field
                              v-model="editedItem.user_info.phone"
                              :label="$t('taxFields.phone')"
                              :error-messages="errors.phone"
                              :rules="
                                rules.required &&
                                rules.digits &&
                                rules.phoneRules
                              "
                              mask="###-###-####"
                            >
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-text-field
                              v-model="editedItem.user_info.address"
                              :label="$t('address.name')"
                              :error-messages="errors.address"
                              :rules="rules.required && rules.minChars"
                            >
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-autocomplete
                              required
                              :items="items"
                              item-value="id"
                              item-text="descripcion"
                              :rules="rules.required"
                              :error-messages="errors.sat_pais_id"
                              class="mr-3"
                              :label="$t('address.country')"
                              v-model="editedItem.user_info.sat_pais_id"
                              :search-input.sync="search"
                              :filter="dataArrayFilter.filter"
                              cache-items
                              flat
                              hide-details
                              auto-select-first
                              clearable
                            >
                              <template slot="selection" slot-scope="data">
                                {{ data.item.c_Pais }} -
                                {{ data.item.descripcion }}
                              </template>
                              <template slot="item" slot-scope="data">
                                {{ data.item.c_Pais }} -
                                {{ data.item.descripcion }}
                              </template>
                            </v-autocomplete>
                          </v-flex>
                          <v-flex sm12>
                            <span>Avatar:</span>
                            <v-img
                              v-if="avatarUrl"
                              :src="avatarUrl"
                              height="200"
                              contain
                              class="mb-2"
                            >
                            </v-img>
                            <vue-dropzone
                              ref="dropzone"
                              id="dropzone"
                              :options="dropzoneOptions"
                              v-on:vdropzone-file-added="fileAdded"
                              v-on:vdropzone-error="fileUploadError"
                              v-on:vdropzone-success="fileUpload"
                            >
                            </vue-dropzone>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-radio-group
                              :label="$t('user.gender')"
                              row
                              :error-messages="errors.gender"
                              :rules="rules.required"
                              v-model="editedItem.user_info.gender"
                            >
                              <v-radio
                                color="primary"
                                :label="$t('user.male')"
                                value="male"
                              ></v-radio>
                              <v-radio
                                color="primary"
                                :label="$t('user.female')"
                                value="female"
                              ></v-radio>
                            </v-radio-group>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-menu
                              v-model="menu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="editedItem.user_info.birthdate"
                                  :label="$t('user.birthDate')"
                                  prepend-icon="event"
                                  readonly
                                  v-on="on"
                                  :error-messages="errors.birthdate"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                :locale="$t('general.locale')"
                                v-model="editedItem.user_info.birthdate"
                                color="primary"
                                @input="menu = false"
                                :max="new Date().toISOString().substr(0, 10)"
                              ></v-date-picker>
                            </v-menu>
                          </v-flex>
                        </v-layout>
                        <v-flex
                          xs12
                          md6
                          v-if="
                            userLogged.roles
                              ? userLogged.roles[0].id === 1
                              : null
                          "
                        >
                          <v-autocomplete
                            v-model="company"
                            :label="$t('general.company')"
                            :items="companies"
                            item-text="name"
                            item-value="id"
                            :rules="rules.required"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-select
                            :disabled="inputDisabled"
                            v-model="editedItem.roles[0]"
                            :label="$t('role.name')"
                            :items="rolFilter"
                            item-text="name"
                            :rules="rules.required"
                            return-object
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-select
                            :disabled="inputDisabled"
                            v-model="editedItem.area[0]"
                            :label="$t('area.name')"
                            :items="areasFilter"
                            item-text="name"
                            :rules="rules.required"
                            return-object
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-select
                            :disabled="inputDisabled"
                            v-model="editedItem.user_info.branch_id"
                            :label="$t('branch.name')"
                            :items="branchFilter"
                            item-text="branch_name"
                            item-value="id"
                            :rules="rules.required"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-select
                            v-model="editedItem.application"
                            :label="$t('general.application')"
                            :items="applications"
                            item-text="name"
                            return-object
                            :rules="rules.required"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-checkbox
                            color="primary"
                            v-model="dbanEmp"
                            :label="$t('user.AddempBa')"
                          />
                        </v-flex>
                        <v-flex v-if="applyFeatures" xs12 md6>
                            <v-text-field
                              v-if="dbanEmp"
                              v-show="viewCampTax"
                              v-model="editedItem.user_info.tax_id"
                              :label="$t('user.Taxid')"
                              :rules="!viewCamp ? rules.minChar: []"
                            >
                            </v-text-field>
                          </v-flex>
                        <v-flex xs12 md6>
                            <v-text-field
                              v-if="dbanEmp"
                              v-model="editedItem.user_info.employee_number"
                              :label="$t('user.employeeNumber')"
                              :error-messages="errors.employee_number"
                              :rules="rules.required && rules.characters">
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-text-field
                              v-if="dbanEmp"
                              v-model="editedItem.user_info.cost_center"
                              :label="$t('user.costCenter')"
                              :error-messages="errors.cost_center"
                              :rules="rules.charactersMax30">
                            </v-text-field>
                          </v-flex>
                          <v-flex v-if="applyFeatures" xs12 md6>
                            <v-text-field
                              v-if="dbanEmp"
                              v-model="editedItem.user_info.deposit_bank"
                              :label="$t('user.depositBank')"
                              :error-messages="errors.deposit_bank"
                              :rules="rules.required && rules.characters">
                            </v-text-field>
                          </v-flex>
                          <v-flex v-if="applyFeatures" xs12 md6>
                            <v-text-field
                              v-if="dbanEmp"
                              v-model="editedItem.user_info.bank_account"
                              :label="$t('user.bankAccount')"
                              :error-messages="errors.bank_account"
                              :rules="rules.required && rules.characters">
                            </v-text-field>
                          </v-flex>
                          <v-flex v-if="applyFeatures" xs12 md6>
                            <v-text-field
                              v-if="dbanEmp"
                              v-show="viewCamp"
                              v-model="editedItem.user_info.rfc"
                              :label="$t('user.RFC')"
                              :rules="!viewCampTax ? rules.taxRul: []"
                              return-masked-value
                              mask="NNNNNNNNNNNNN"
                              :error-messages="errors.rfc"
                            >
                            </v-text-field>
                          </v-flex>
                        <v-flex xs12>
                          <v-checkbox
                            color="primary"
                            v-model="hadAmex"
                            :label="$t('conciliation.cardQ')"
                          />
                        </v-flex>
                        <v-flex v-if="hadAmex" xs12 md6>
                          <v-text-field
                            v-model="editedItem.card_number"
                            :label="$t('general.cardNumber')"
                            return-masked-value
                            mask="####-######-#####-#####"
                          >
                          </v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-form>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" round flat @click="close">
                {{ $t('general.cancel') }}
              </v-btn>
              <v-btn color="primary" round depressed :loading="loading" :disabled="loading"
                @click=" $store.state.userLogged.roles[0].id === 1 && editedIndex === -1 ? confirmAdd() : validate()">
                {{ $t('general.save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogdelete" max-width="500px" persistent>
          <v-card>
            <v-toolbar flat>
              <h2 class="font-weight-black error--text mb-0">
                {{ $t('user.delete') }}
              </h2>
            </v-toolbar>
            <v-card-text>
              <p
                v-html="
                  $t('validation.deleteUserQuestion', {
                    name: editedItem.name,
                    email: editedItem.email,
                  })
                "
              ></p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" round flat @click="closeDelete">{{
                $t('general.cancel')
              }}</v-btn>
              <v-btn color="error" round depressed @click="confirmDelete">{{
                $t('general.delete')
              }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogBatch" scrollable persistent fullscreen>
          <v-btn slot="activator" color="primary" round outline>
            <v-icon left>people</v-icon>
            {{ $t('user.addBatch') }}
          </v-btn>
          <v-card>
            <v-toolbar flat>
              <h2 class="font-weight-black primary--text mb-0">
                {{ $t('user.addBatch') }}
              </h2>
              <v-spacer></v-spacer>
              <v-btn
                :loading="loading"
                :disabled="selected.length === 0 || loading"
                color="primary"
                round
                @click="activateBatch"
              >
                {{ $t('user.activate') }}
              </v-btn>
              <v-btn round flat @click="closeBatch">
                {{ $t('general.cancel') }}
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid grid-list-md>
                <v-layout row wrap>
                  <v-flex xs12 v-if="!batchLoaded">
                    <v-btn
                      color="primary"
                      outline
                      round
                      flat
                      :loading="loading"
                      :disabled="loading"
                      @click="downloadTemplate"
                    >
                      <v-icon left>cloud_download</v-icon>
                      {{ $t('user.downloadTemplate') }}
                    </v-btn>
                    <vue-dropzone
                      ref="dropzoneBatch"
                      id="dropzoneBatch"
                      :options="dropzoneBatchOptions"
                      v-on:vdropzone-error="fileBatchError"
                      v-on:vdropzone-success="fileBatchUpload"
                    >
                    </vue-dropzone>
                  </v-flex>
                  <v-flex xs12 v-if="batchLoaded">
                    <v-data-table
                      v-model="selected"
                      :headers="headersBatch"
                      :items="usersBatch"
                      class="elevation-1"
                      :pagination.sync="paginationBatch"
                      select-all
                      item-key="index"
                      hide-actions
                    >
                      <template v-slot:headers="props">
                        <tr class="bg-heavy-rain">
                          <th>
                            <v-checkbox
                              :input-value="props.all"
                              :indeterminate="props.indeterminate"
                              primary
                              hide-details
                              @click.stop="toggleAll"
                            ></v-checkbox>
                          </th>
                          <th
                            v-for="header in props.headers"
                            :key="header.text"
                            :class="['font-weight-black white--text column']"
                          >
                            <h2 class="font-weight-black primary--text mb-0">
                              {{ header.text }}
                            </h2>
                          </th>
                        </tr>
                      </template>
                      <template v-slot:items="props">
                        <tr :active="props.selected">
                          <td>
                            <v-checkbox
                              :input-value="props.selected"
                              primary
                              hide-details
                              v-model="props.selected"
                            ></v-checkbox>
                          </td>
                          <td class="text-xs-center">
                            <v-text-field
                              v-model="props.item.name"
                              :error-messages="
                                usersBatchErrors[
                                  'users.' + props.index + '.name'
                                ]
                              "
                            ></v-text-field>
                          </td>
                          <td class="text-xs-center">
                            <v-text-field
                              v-model="props.item.email"
                              :error-messages="
                                usersBatchErrors[
                                  'users.' + props.index + '.email'
                                ]
                              "
                            ></v-text-field>
                          </td>
                          <td class="text-xs-center">
                            <v-text-field
                              v-model="props.item.password"
                              :error-messages="
                                usersBatchErrors[
                                  'users.' + props.index + '.password'
                                ]
                              "
                            ></v-text-field>
                          </td>
                          <td class="text-xs-center">
                            <v-text-field
                              v-model="props.item.phone"
                              :error-messages="
                                usersBatchErrors[
                                  'users.' + props.index + '.phone'
                                ]
                              "
                            ></v-text-field>
                          </td>
                          <td class="text-xs-center">
                            <v-text-field
                              v-model="props.item.address"
                              :error-messages="
                                usersBatchErrors[
                                  'users.' + props.index + '.address'
                                ]
                              "
                            ></v-text-field>
                          </td>
                          <td class="text-xs-center">
                            <v-select
                              :items="satPais"
                              item-value="id"
                              item-text="descripcion"
                              class="mr-3"
                              :error-messages="
                                usersBatchErrors[
                                  'users.' + props.index + '.sat_pais_id'
                                ]
                              "
                              v-model="props.item.sat_pais_id"
                            >
                              <template slot="selection" slot-scope="data">
                                {{ data.item.c_Pais }} -
                                {{ data.item.descripcion }}
                              </template>
                              <template slot="item" slot-scope="data">
                                {{ data.item.c_Pais }} -
                                {{ data.item.descripcion }}
                              </template>
                            </v-select>
                          </td>
                          <td class="text-xs-center">
                            <v-radio-group
                              row
                              :error-messages="
                                usersBatchErrors[
                                  'users.' + props.index + '.gender'
                                ]
                              "
                              v-model="props.item.gender"
                            >
                              <v-radio
                                color="primary"
                                :label="$t('user.male')"
                                value="male"
                              ></v-radio>
                              <v-radio
                                color="primary"
                                :label="$t('user.female')"
                                value="female"
                              ></v-radio>
                            </v-radio-group>
                          </td>
                          <td class="text-xs-center">
                            <v-select
                              v-model="props.item.role_id"
                              :error-messages="
                                usersBatchErrors[
                                  'users.' + props.index + '.role_id'
                                ]
                              "
                              :items="rolFilter"
                              item-text="name"
                              item-value="id"
                            ></v-select>
                          </td>
                          <td class="text-xs-center">
                            <v-select
                              v-model="props.item.area_id"
                              :error-messages="
                                usersBatchErrors[
                                  'users.' + props.index + '.area_id'
                                ]
                              "
                              :items="areasFilter"
                              item-text="name"
                              item-value="id"
                            ></v-select>
                          </td>
                          <td class="text-xs-center">
                            <v-select
                              v-model="props.item.branch_id"
                              :error-messages="
                                usersBatchErrors[
                                  'users.' + props.index + '.branch_id'
                                ]
                              "
                              :items="branchFilter"
                              item-text="branch_name"
                              item-value="id"
                            ></v-select>
                          </td>
                          <td class="text-xs-center">
                            <v-text-field
                              v-model="props.item.card_number"
                              :error-messages="
                                usersBatchErrors[
                                  'users.' + props.index + '.card_number'
                                ]
                              "
                            ></v-text-field>
                          </td>
                          <td class="text-xs-center">
                            <v-select
                              v-model="props.item.application_id"
                              :error-messages="
                                usersBatchErrors[
                                  'users.' + props.index + '.application_id'
                                ]
                              "
                              :items="applications"
                              item-text="name"
                              item-value="id"
                            ></v-select>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-btn slot="activator" color="primary" @click="downloadReport" round outline>
            <v-icon left>download</v-icon>
            {{ $t('general.downloadReport') }}
          </v-btn>
      </v-layout>
      <v-data-table
        :headers="headers"
        :items="users"
        class="elevation-1"
        :loading="loadingItems"
        :rows-per-page-items="[10, 15, 25]"
        :pagination.sync="pagination"
        :items-per-page="pagination.rowsPerPage"
        :total-items="pagination.totalItems"
        @update:pagination="checkPageChange"
      >
        <template v-slot:headers="props">
          <tr class="bg-heavy-rain">
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="[
                'column',
                header.sortable ? 'sortable' : '',
                pagination.descending ? 'desc' : 'asc',
                header.value === pagination.sortBy ? 'active' : '',
              ]"
              @click="changeSort(header)"
            >
              <h2 class="font-weight-black primary--text mb-0">
                <v-icon small class="primary--text" v-if="header.sortable"
                  >arrow_upward</v-icon
                >
                {{ header.text }}
              </h2>
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <td width="60px">{{ props.item.id }}</td>
          <td class="text-xs-center">{{ props.item.name }}</td>
          <td class="text-xs-center">{{ props.item.email }}</td>
          <td class="text-xs-center">{{ props.item.card_number }}</td>
          <td
            class="text-xs-center"
            v-if="
              $store.state.userLogged.roles[0] &&
              $store.state.userLogged.roles[0].id === 1
            "
          >
            {{ props.item.company[0] ? props.item.company[0].name : '- -' }}
          </td>
          <td
            class="text-xs-center"
            v-if="
              $store.state.userLogged.roles[0] &&
              $store.state.userLogged.roles[0].id === 2
            "
          >
            {{ props.item.area[0] ? props.item.area[0].name : '- -' }}
          </td>
          <td class="text-xs-center">
            {{ props.item.roles[0] ? props.item.roles[0].name : '- -' }}
          </td>
          <td class="text-xs-center">
            {{ props.item.active === 1 ? $t('general.active') : $t('general.inactive') }}
          </td>
          <td class="justify-center layout px-0">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark v-on="on" icon>
                  <v-icon>menu</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-tile
                  :disabled="props.item.status === 0"
                  @click="editItem(props.item)"
                >
                  <v-list-tile-avatar>
                    <v-icon :disabled="props.item.status === 0" color="info"
                      >edit</v-icon
                    >
                  </v-list-tile-avatar>
                  <v-list-tile-title>{{ $t('general.edit') }}</v-list-tile-title>
                </v-list-tile>
                <!-- COMENTADO TEMPORALMENTE -->
                <!-- <v-list-tile @click="deleteItemDialog(props.item)">
                  <v-list-tile-avatar>
                    <v-icon color="error">delete</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-title>{{
                    $t('general.delete')
                  }}</v-list-tile-title>
                </v-list-tile> -->
                <v-list-tile :disabled="loadingChangeStatus" @click="changeStatusUser(props.item)">
                  <v-list-tile-avatar>
                    <v-icon color="info">mdi-account-convert</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-title>{{
                    props.item.active === 1 ? 'Desactivar' : 'Activar'
                  }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
            <!--v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    :disabled="props.item.name === 'Ed Rosas'"
                    outline
                    icon
                    color="info"
                    v-on="on"
                    @click="editItem(props.item)"
                  >
                    <v-icon small>edit</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('general.edit') }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                  outline
                  icon
                  color="error"
                  v-on="on"
                  :disabled="currentUser(props.item)"
                  @click="deleteItemDialog(props.item)"
                >
                  <v-icon small>delete</v-icon>
                </v-btn>
                </template>
                <span>{{ $t('general.delete') }}</span>
              </v-tooltip-->
          </td>
        </template>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">{{
            $t('general.reset')
          }}</v-btn>
        </template>
      </v-data-table>
      <v-dialog
        v-if="
          $store.state.userLogged.roles &&
          $store.state.userLogged.roles[0].id === 1
        "
        v-model="confirmDialog"
        max-width="500px"
        persistent
      >
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('user.addConfirm') }}
            </h2>
          </v-toolbar>
          <v-card-text>
            <p v-html="$t('user.addQuestion')"></p>
            <p>
              <span class="font-weight-black primary--text">Usuario:</span>
              {{ editedItem.name ? editedItem.name : '' }}
            </p>
            <p>
              <span class="font-weight-black primary--text">Email:</span>
              {{ editedItem.email ? editedItem.email : '' }}
            </p>
            <p>
              <span class="font-weight-black primary--text">Empresa:</span>
              {{ company !== null ? findCompany(company) : '' }}
            </p>
            <p>
              <span class="font-weight-black primary--text">Aplicación:</span>
              {{ editedItem.application ? editedItem.application.name : '' }}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" round flat @click="closeConfirmAdd">{{
              $t('general.cancel')
            }}</v-btn>
            <v-btn
              :loading="loading"
              :disabled="loading"
              color="primary"
              round
              depressed
              @click="validate"
              >{{ $t('general.accept') }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import vue2Dropzone from 'vue2-dropzone'
export default {
  name: 'usersComponent',
  components: {
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      settings: {},
      countrySetting: {},
      viewCamp: false,
      viewCampTax: false,
      userSearch: '',
      valid: false,
      avatarUrl: null,
      avatarId: null,
      search: null,
      autocompleteLoading: false,
      autocompleteSelect: '',
      hadAmex: false,
      dbanEmp: false,
      items: [],
      dropzoneOptions: {
        url: process.env.HOST + 'api/File',
        dictDefaultMessage: this.$t('dropzone.default', {
          size: '5',
          unit: 'MB',
        }),
        dictResponseError: this.$t('dropzone.responseError'),
        dictFileTooBig: this.$t('dropzone.fileTooBig'),
        dictInvalidFileType: this.$t('dropzone.invalidFileType'),
        dictRemoveFile: this.$t('dropzone.removeFile'),
        dictRemoveFileConfirmation: this.$t('dropzone.removeFileConfirmation'),
        dictMaxFilesExceeded: this.$t('dropzone.maxFilesExceeded'),
        addRemoveLinks: true,
        thumbnailWidth: 150,
        maxFilesize: 5,
        paramName: 'path',
        acceptedFiles: '.jpeg,.jpg,.png',
        maxFiles: 1,
        headers: {
          Authorization: 'Bearer ' + this.$store.state.userState.access_token,
        },
        params: {
          dirname: 'USER_AVATAR',
          is_public: 1,
          user_id: this.$store.state.userLogged.id,
        },
      },
      dropzoneBatchOptions: {
        url: process.env.HOST + 'api/user/massive/validate',
        dictDefaultMessage: this.$t('dropzone.uploadUserBatch', {
          size: '5',
          unit: 'MB',
        }),
        dictResponseError: this.$t('dropzone.responseError'),
        dictFileTooBig: this.$t('dropzone.fileTooBig'),
        dictInvalidFileType: this.$t('dropzone.invalidFileType'),
        dictRemoveFile: this.$t('dropzone.removeFile'),
        dictRemoveFileConfirmation: this.$t('dropzone.removeFileConfirmation'),
        dictMaxFilesExceeded: this.$t('dropzone.maxFilesExceeded'),
        addRemoveLinks: true,
        thumbnailWidth: 150,
        maxFilesize: 5,
        paramName: 'template',
        acceptedFiles: '.xlsx',
        maxFiles: 1,
        headers: {
          Authorization: 'Bearer ' + this.$store.state.userState.access_token,
        },
      },
      errors: {},
      timeout: 6000,
      showPass: false,
      loading: false,
      loadingItems: true,
      confirmDialog: false,
      dialog: false,
      dialogdelete: false,
      dialogBatch: false,
      batchLoaded: false,
      inputDisabled: false,
      users: [],
      usersBatch: [],
      usersBatchErrors: [],
      paginationBatch: {
        sortBy: '',
        rowsPerPage: -1,
      },
      selected: [],
      company: null,
      companies: [],
      roles: [],
      areas: [],
      branches: [],
      satPais: [],
      applications: [],
      user: null,
      editedIndex: -1,
      editedItem: {
        id: null,
        name: '',
        email: '',
        email_original: '',
        password: '',
        user_info: {
          phone: '',
          address: '',
          sat_pais_id: 151,
          rfc: '',
          tax_id: '',
          avatar: '',
          gender: '',
          birthdate: '',
          branch_id: null,
          employee_number: '',
          policy_address: '',
          deposit_bank: '',
          bank_account: '',
          cost_center: ''
        },
        company: [
          {
            id: null,
            tax_id: ''
          },
        ],
        country: [
        {
            id: null,
            c_Pais: 'MEX',
          },
        ],
        roles: [],
        area: [],
        application: {
          id: 1,
          name: 'Gastos',
        },
        card_number: '',
      },
      defaultItem: {
        id: null,
        name: '',
        email: '',
        email_original: '',
        password: '',
        user_info: {
          phone: '',
          address: '',
          sat_pais_id: 151,
          rfc: '',
          tax_id: '',
          avatar: '',
          gender: '',
          birthdate: '',
          branch_id: null,
          employee_number: '',
          policy_address: '',
          deposit_bank: '',
          bank_account: '',
          cost_center: ''
        },
        company: [
          {
            id: null,
          },
        ],
        country: [
        {
            id: null,
            c_Pais: 'MEX',
          },
        ],
        roles: [],
        area: [],
        application: {
          id: 1,
          name: 'Gastos',
        },
        card_number: '',
      },
      pagination: {
        sortBy: 'id',
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
      },
      menu: false,
      menu2: false,
      loadingChangeStatus: false,
      initialPage: true
    }
  },
  computed: {
    applyFeatures(){
      if(this.$store.state.userLogged.company === undefined){
        return false
      }

      if(this.$store.state.userLogged.company[0].features.find(x => x.name === 'CATALOG_EXTRA_FIELDS_FREY')){
        return true
      }

      return false
    },
    heading() {
      return this.$t('general.users')
    },
    subheading() {
      return this.$t('user.subtitle')
    },
    icon() {
      return 'fas fa-users fa-fw icon-color'
    },
    rules() {
      return this.$validationRules()
    },
    userLogged() {
      return this.$store.state.userLogged
    },
    headers() {
      if (
        this.$store.state.userLogged.roles &&
        this.$store.state.userLogged.roles[0].id === 1
      ) {
        return [
          {
            text: '#',
            align: 'left',
            sortable: true,
            value: 'id',
          },
          {
            text: this.$t('general.name'),
            align: 'left',
            sortable: true,
            value: 'name',
          },
          {
            text: this.$t('general.email'),
            align: 'left',
            sortable: true,
            value: 'email',
          },
          {
            text: this.$t('general.cardAbbr'),
            align: 'left',
            sortable: true,
            value: 'card_number',
          },
          {
            text: this.$t('general.company'),
            align: 'left',
            sortable: false,
            value: 'company[0].name',
          },
          {
            text: this.$t('role.name'),
            align: 'left',
            sortable: false,
            value: 'roles[0].name',
          },
          {
            text: this.$t('general.actions'),
            align: 'center',
            value: 'name',
            sortable: false,
          },
        ]
      } else {
        return [
          {
            text: '#',
            align: 'left',
            sortable: true,
            value: 'id',
          },
          {
            text: this.$t('general.name'),
            align: 'left',
            sortable: true,
            value: 'name',
          },
          {
            text: this.$t('general.email'),
            align: 'left',
            sortable: true,
            value: 'email',
          },
          {
            text: this.$t('general.cardAbbr'),
            align: 'left',
            sortable: true,
            value: 'card_number',
          },
          {
            text: this.$t('area.name'),
            align: 'left',
            sortable: false,
            value: 'area[0].name',
          },
          {
            text: this.$t('role.name'),
            align: 'left',
            sortable: false,
            value: 'roles[0].name',
          },
          {
            text: this.$t('general.status'),
            align: 'left',
            sortable: true,
            value: 'status',
          },
          {
            text: this.$t('general.actions'),
            align: 'center',
            value: 'name',
            sortable: false,
          },
        ]
      }
    },
    headersBatch() {
      return [
        {
          text: this.$t('general.name'),
          align: 'left',
          sortable: true,
          value: 'name',
        },
        {
          text: this.$t('general.email'),
          align: 'left',
          sortable: true,
          value: 'email',
        },
        {
          text: this.$t('login.password'),
          align: 'left',
          sortable: true,
          value: 'password',
        },
        {
          text: this.$t('taxFields.phone'),
          align: 'left',
          sortable: true,
          value: 'phone',
        },
        {
          text: this.$t('address.name'),
          align: 'left',
          sortable: true,
          value: 'address',
        },
        {
          text: this.$t('general.country'),
          align: 'left',
          sortable: true,
          value: 'country',
        },
        {
          text: this.$t('user.gender'),
          align: 'left',
          sortable: true,
          value: 'gender',
        },
        {
          text: this.$t('role.name'),
          align: 'left',
          sortable: true,
          value: 'role',
        },
        {
          text: this.$t('area.name'),
          align: 'left',
          sortable: true,
          value: 'area',
        },
        {
          text: this.$t('branch.name'),
          align: 'left',
          sortable: true,
          value: 'branch',
        },
        {
          text: this.$t('pettyCash.cardNumber'),
          align: 'left',
          sortable: true,
          value: 'cardNumber',
        },
        {
          text: this.$t('general.application'),
          align: 'left',
          sortable: true,
          value: 'application',
        },
      ]
    },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t('user.add')
        : this.$t('user.edit')
    },
    editingItem() {
      return this.editedIndex !== -1
    },
    isNewItem() {
      return this.editedIndex === -1
    },
    areasFilter() {
      if (this.userLogged.roles ? this.userLogged.roles[0].id === 1 : false) {
        return this.areas.filter((item) => item.company_id === this.company)
      } else if (
        this.userLogged.roles ? this.userLogged.roles[0].id === 2 : false
      ) {
        return this.areas.filter(
          (item) => item.company_id === this.userLogged.company[0].id
        )
      }
    },
    rolFilter() {
      // if (this.userLogged.roles ? this.userLogged.roles[0].id === 1 : false) {
      //   return this.roles
      // } else if (this.userLogged.roles ? this.userLogged.roles[0].id === 2 : false) {
      //   return this.roles.slice(1)
      // }
      return this.roles.slice(1)
    },
    branchFilter() {
      if (this.company === null) {
        return []
      } else {
        return this.companies.find((item) => item.id === this.company).branch
      }
    },
    dataArrayFilter() {
      return this.$searchCountry()
    },
  },
  watch: {
    settings(){
      this.filterCountry()
      this.viewMX()
    },
    dialog(val) {
      val || this.close()
      this.$refs.form.resetValidation()
    },
    companies() {
      if (this.userLogged.roles ? this.userLogged.roles[0].id === 2 : false) {
        this.editedItem.company[0].id = this.userLogged.company[0].id
        this.company = this.userLogged.company[0].id
      }
    },
    userLogged() {
      this.dropzoneOptions.params.user_id = this.userLogged.id
      if (this.$store.state.userLogged.roles[0].id === 1) {
        this.inputDisabled = true
      }
      this.initialize()
    },
    search(val) {
      this.querySelection(val)
      this.dataArrayFilter.search(this.editedItem.user_info.sat_pais_id, val)
    },
    company() {
      if (this.userLogged.roles[0].id === 1) {
        this.editedItem.roles[0] = this.rolFilter[0]
        this.editedItem.area[0] = this.areasFilter[0]
        this.editedItem.user_info.branch_id =
          this.branchFilter.length > 0 ? this.branchFilter[0].id : null
      }
    },
    hadAmex(val) {
      if (!val) {
        this.editedItem.card_number = ''
      }
    },
    dbanEmp(val) {
      if (!val) {
        this.editedItem.user_info.employee_number = ''
        this.editedItem.user_info.cost_center = ''
        this.editedItem.user_info.deposit_bank = ''
        this.editedItem.user_info.bank_account = ''
        this.editedItem.user_info.tax_id = ''
        this.editedItem.user_info.rfc = ''
      }
    },
  },
  created() {
    this.initialize()
  },
  methods: {
    downloadReport() {
      this.$emit('downloadReport', {
        context: this,
      })
    },
    searching () {
      this.pagination.page = 1
      this.pagination.perPage = 5
      this.loadingItems = true
      this.refresh()
    },
    checkPageChange() {
      if (this.initialPage) {
        this.initialPage = false
      } else {
        // this.valSearch = ''
        this.loadingItems = true
        this.refresh()
      }
    },
    changeStatusUser({ active, id }) {
      this.loadingChangeStatus = true
      if (active === 1) this.$emit('disabledUser', {id, ctx: this})
      if (active === 0) this.$emit('activeUser', {id, ctx: this})
    },
    currentUser(user) {
      return this.$store.state.userLogged.id === user.id
    },
    // usersFilter () {
    //   if (this.userLogged.roles ? this.userLogged.roles[0].id === 1 : false) {
    //     return this.users
    //   } else if (this.userLogged.roles ? this.userLogged.roles[0].id === 2 : false) {
    //     return this.users.filter(item => item.company ? item.company[0].id === this.userLogged.company[0].id : false)
    //   }
    // },
    filterCountry () {
    const foundCountrySetting = this.settings.find(x => x.setting_type.name == "st.country" && x.company_id == this.$store.state.userLogged.company[0].id)
    this.countrySetting = foundCountrySetting ? foundCountrySetting : { value: { c_Pais: 'MEX' } }
    this.viewCamp = this.countrySetting.value.c_Pais
    this.editedItem.country.id = this.countrySetting.value
    this.defaultItem.country.id = this.countrySetting.value
    },
    // filterCountry () {
    //   this.countrySetting = this.settings.find(x => x.setting_type.name == "st.country" && x.company_id == this.$store.state.userLogged.company[0].id)
    //   this.editedItem.country.id = this.countrySetting.value
    //   this.defaultItem.country.id = this.countrySetting.value
    // },
    viewMX(){
      if(this.settings && this.$store.state.userLogged){
        let countrySetting =  this.settings.find(x => x.setting_type.name == "st.country" && x.company_id == this.$store.state.userLogged.company[0].id)
        let cPais = countrySetting.value.c_Pais
        this.viewCamp= cPais == 'MEX'
        this.viewCampTax = cPais !== 'MEX'
      }
    },
    changeSort(header) {
      if (header.sortable) {
        if (this.pagination.sortBy === header.value) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.descending = false
        }
        this.pagination.sortBy = header.value
      } else {
        this.pagination.sortBy = ''
      }
      this.refresh()
    },
    confirmAdd() {
      this.errors = {}
      if (this.$refs.form.validate()) {
        this.confirmDialog = true
      } else {
        this.showNotification(this.$t('general.validationError'), 'error', -1)
      }
    },
    closeConfirmAdd() {
      this.confirmDialog = false
    },
    findCompany(item) {
      return this.companies.find((item) => item.id === this.company).name
    },
    fileAdded(file) {
      let fileType = file.type
      if (fileType === 'image/jpeg') {
        this.dropzoneOptions.params.files_type_id = 5
      } else if (fileType === 'image/png') {
        this.dropzoneOptions.params.files_type_id = 6
      }
    },
    fileUploadError(file, message, xhr) {
      this.showNotification(message, 'error', -1)
    },
    fileUpload(file, response) {
      this.editedItem.user_info.avatar = response.data.id
      this.avatarId = response.data.id
    },
    fileBatchUpload(file, response) {
      this.batchLoaded = true
      this.usersBatch = this.processUsersBatch(response.data.users)
    },
    fileBatchError(file, message, xhr) {
      let response = message
      if (response.data) {
        if (response.data.users.length > 0) {
          this.batchLoaded = true
          this.usersBatch = this.processUsersBatch(response.data.users)
          this.usersBatchErrors = response.errors
        } else {
          this.showNotification(response.data.message, 'error', -1)
        }
      } else {
        this.showNotification(response.message, 'error', -1)
      }
    },
    processUsersBatch(usersBatch) {
      let index = 0
      usersBatch.forEach((element) => {
        element.index = index
        index++
      })
      return usersBatch
    },
    downloadTemplate() {
      this.loading = true
      this.$emit('downloadTemplate', {
        context: this,
      })
    },
    validate() {
      this.errors = {}
      if (this.$refs.form.validate()) {
        this.save()
      }
    },
    initialize() {
      if (this.userLogged.roles && this.userLogged.roles[0].id === 1) {
        this.$emit('initializeUsers', { context: this })
        this.inputDisabled = true
      } else if (this.userLogged.roles && this.userLogged.roles[0].id === 2) {
        this.$emit('initializeAdmin', {
          company_id: this.$store.state.userLogged.company[0].id,
          context: this,
        })
      }
    },
    getRefresh () {
      let event = {
        context: this
      }
      if (this.userLogged.roles && this.userLogged.roles[0].id === 1) {
        this.$store.dispatch('users/get', { event })
        this.inputDisabled = true
      } else if (this.userLogged.roles && this.userLogged.roles[0].id === 2) {
        event.company_id = this.$store.state.userLogged.company[0].id
        this.$store.dispatch('users/getByCompany', { event })
      }
    },
    editItem(item) {
      if(item.user_info !== null){
        item.user_info.employee_number = item.user_info.employee_number === null ? '' : item.user_info.employee_number
        item.user_info.cost_center = item.user_info.cost_center === null ? '' : item.user_info.cost_center
        item.user_info.policy_address = item.user_info.policy_address === null ? '' : item.user_info.policy_address
        item.user_info.deposit_bank = item.user_info.deposit_bank === null ? '' : item.user_info.deposit_bank
        item.user_info.bank_account = item.user_info.bank_account === null ? '' : item.user_info.bank_account
        item.user_info.rfc = item.user_info.rfc === null ? '' : item.user_info.rfc
        item.user_info.tax_id= item.user_info.tax_id=== null ? '' : item.user_info.tax_id
      }

      if (item.user_info.avatar) {
        this.avatarUrl = item.user_info.avatar.public_url
      }
      this.hadAmex = !!item.card_number
      this.dbanEmp =  (!!item.user_info.tax_id && this.viewCampTax) 
      || !!item.user_info.employee_number 
      || !!item.user_info.cost_center
      || !!item.user_info.deposit_bank 
      || !!item.user_info.bank_account 
      || (!!item.user_info.rfc && this.viewCamp)
      this.editedIndex = this.users.indexOf(item)
      this.editedItem = Object.assign({}, JSON.parse(JSON.stringify(item)))
      if (this.editedItem.user_info.sat_pais_id) {
        this.items.push(this.editedItem.user_info.sat_pais_id)
      }
      let temp = this.editedItem.application[0]
      this.editedItem.application = null
      this.editedItem.application = temp
      this.editedItem.application_original = temp
      this.editedItem.rol_original = this.editedItem.roles[0]
      
      if (this.userLogged.roles[0].id) {
        this.company = this.editedItem.company[0]
          ? this.editedItem.company[0].id
          : 1
      }
      this.dialog = true
    },
    deleteItemDialog(item) {
      if (item !== undefined) {
        this.editedIndex = this.users.indexOf(item)
        this.editedItem = Object.assign({}, JSON.parse(JSON.stringify(item)))
      }
      this.dialogdelete = true
    },
    confirmDelete() {
      this.delete(this.editedItem, this.editedIndex)
      this.closeDelete()
      this.close()
    },
    closeDelete() {
      this.dialogdelete = false
      this.loading = false
    },
    close() {
      this.dialog = false
      this.avatarUrl = null
      this.avatarId = null
      
      if (this.userLogged.roles ? this.userLogged.roles[0].id === 1 : false) {
        this.editedItem = Object.assign(
          {},
          JSON.parse(JSON.stringify(this.defaultItem))
        )
        this.company = null
      } else if (
        this.userLogged.roles ? this.userLogged.roles[0].id === 2 : false
      ) {
        this.defaultItem.company[0].id = this.userLogged.company[0].id
        this.editedItem = Object.assign(
          {},
          JSON.parse(JSON.stringify(this.defaultItem))
        )
      }
      if (this.$refs.dropzone !== undefined) {
        this.$refs.dropzone.removeAllFiles()
      }
      this.hadAmex = false
      this.dbanEmp = false
      this.editedIndex = -1
      this.loading = false
      this.errors = {}
    },
    closeBatch() {
      this.loading = false
      this.dialogBatch = false
      this.batchLoaded = false
      this.usersBatch = []
      this.usersBatchErrors = []
      this.selected = []
      this.refresh()
    },
    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.usersBatch.slice()
    },
    activateBatch() {
      this.loading = true
      this.$emit('postMassiveCreate', {
        users: this.selected,
        context: this,
      })
    },
    save() {
      let cardNumberUser = this.editedItem.card_number
      if (cardNumberUser) {
        const cardNumberFinal1 = cardNumberUser.replace(/-(?![\d])/, '')
        this.editedItem.card_number = cardNumberFinal1
      }
      this.loading = true
      if (this.userLogged.roles[0].id === 1) {
        this.editedItem.company[0].id = this.company
      }
      if (this.editedIndex > -1) {
        if (this.editedItem.area[0].id !== this.editedItem.area_original[0].id) return this.putFirstArea(this.editedItem)
        this.put()
      } else {
        this.closeConfirmAdd()
        this.post()
      }
    },
    putFirstArea(editedItem){
      this.$emit('putUserByChangeArea', {
        context: this,
        user: editedItem,
        area: editedItem.area_original[0], 
        newArea:editedItem.area[0]
      })
    },
    post() {
      this.$emit('postUser', {
        item: this.editedItem,
        context: this,
      })
    },
    put() {
      this.$emit('putUser', {
        item: this.editedItem,
        index: this.editedIndex,
        avatarId: this.avatarId,
        context: this,
      })
    },
    delete() {
      this.$emit('deleteUser', {
        item: this.editedItem,
        index: this.editedIndex,
        context: this,
      })
    },
    refresh() {
      if (this.$store.state.userLogged.roles[0].id === 1) {
        this.$emit('refresh', { context: this })
      } else {
        this.$emit('refreshAdmin', {
          company_id: this.$store.state.userLogged.company[0].id,
          context: this,
        })
      }
    },
    querySelection(val) {
      this.items = this.dataArrayFilter.querySelection(this.satPais, val)
    }
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/users.component.vue